import pageKey from 'ui/constants/pageKey';

export const sendDataInChunks = (
  dataArray: any,
  chunkSize: any,
  callback: any,
  setCollect: any,
  type: any
) => {
  for (let i = 0; i < dataArray.length; i += chunkSize) {
    const chunk = dataArray.slice(i, i + chunkSize);
    const sortByPosition = (arr) => {
      return arr.sort((a, b) => {
        const positionA = parseInt(a?.position?.split(' ')[0]);
        const positionB = parseInt(b?.position?.split(' ')[0]);
        return positionA - positionB;
      });
    };
    const sortByPositionNCP = (arr) => {
      return arr.sort((a, b) => {
        const positionA = parseInt(a.position);
        const positionB = parseInt(b.position);
        return positionA - positionB;
      });
    };
    callback(
      type === pageKey.newCarPurchase || type === pageKey.usedCarPurchase
        ? sortByPositionNCP(chunk)
        : sortByPosition(chunk)
    );
    setCollect([]);
  }
};
